<template>
  <div>
    <h3 class="md-title">
      <md-icon>trip_origin</md-icon>
      {{ $route.name }}
    </h3>
    <div class="md-layout">
      <md-card class="search-area">
        <md-card-header md-alignment="space-between">
          <h4 class="title">
            <md-icon>search</md-icon>
            검색조건
          </h4>
        </md-card-header>
        <md-card-content>
          <table class="flex-table">
            <tr>
              <th>임원직위</th>
              <td>
                <select v-focus v-model="query.memberorgGb">
                  <option value="">임원 레벨코드 선택</option>
                  <option v-for="item in memberOrgGbList" :key="item.code" :value="item.code" :label="item.codeNm"></option>
                </select>
              </td>
              <th>납부회수</th>
              <td>
                <div class="inline-flex">
                  <input type="text" v-model="query.feeCountFrom" v-on:keyup.enter="searchQuery" maxlength="4">
                  <span>~</span>
                  <input type="text" maxlength="4" v-model="query.feeCountTo" v-on:keyup.enter="searchQuery">
                  <span style="color:blue; font-weight: bold; line-height: 22px">숫자만 입력</span>
                </div>
              </td>
              <th>평생회비납부자</th>
              <td>
                <label>
                  <input type="radio" value="Y" v-model="query.memberGb">Y
                </label>
                <label>
                  <input type="radio" value="N" v-model="query.memberGb">N
                </label>
              </td>
              <th>회비 등급</th>
              <td>
                <div class="inline-flex">
                  <select v-model="query.feeLevelCd">
                    <option value="">회원 등급 선택</option>
                    <option v-for="item in feeLevelList" :key="item.code" :value="item.code" :label="item.codeNm"></option>
                  </select>
                </div>
              </td>
            </tr>
          </table>
        </md-card-content>
        <md-card-actions md-alignment="right">
          <md-button class="md-info md-sm" @click="searchQuery">
            <md-icon>check</md-icon>검 색
          </md-button>
          <md-button class="md-default md-sm" @click="clearQuery">
            <md-icon>clear</md-icon>초기화
          </md-button>
          <md-button class="md-success md-sm" :disabled="this.pagination.total === 0" @click="downloadExcel" v-exel-btn="[5,3]">
            <md-icon>get_app</md-icon>Excel 다운로드
          </md-button>
        </md-card-actions>

      </md-card>

      <md-card>
        <md-card-header md-alignment="space-between">
          <h4 class="title">
            <md-icon>assignment</md-icon>검색 결과
          </h4>
        </md-card-header>
        <md-card-content>
          <div class="table-header-info">
            <div>총 {{ total }} 건의 검색결과가 있습니다.</div>
            <div>
              <select v-model="pagination.perPage" name="pages" @change="perPageChange">
                <option v-for="item in pagination.perPageOptions" :key="item" :label="item" :value="item">
                  {{ item }}
                </option>
              </select>
            </div>
          </div>

          <grid ref="feeCountLevelListGrid"
                :data="gridProps.data"
                :columns="gridProps.columns"
                :options="gridProps.options"
                :theme="gridProps.theme"
                :rowHeaders="gridProps.rowHeaders"
                :columnOptions="gridProps.columnOptions"
                :language="gridProps.lang"
                @response="response"
          ></grid>

        </md-card-content>
        <md-card-actions md-alignment="space-between">
          <div class="pagination-no-border pagination-success"></div>
          <div>
            <select class="w120" v-model="updatableMemberLevel">
              <option value="">회원 등급 선택</option>
              <option v-for="item in feeLevelList" :key="item.code" :value="item.code" :label="item.codeNm"></option>
            </select>
            <md-button class="md-info md-sm" @click="bundleUpdate">
              <md-icon>sync_alt</md-icon>일괄 업데이트
            </md-button>
          </div>
        </md-card-actions>
      </md-card>
    </div>
  </div>
</template>

<script>

import Swal from "sweetalert2";
import formatter from "@/kuaa/kuaa-formatter";
import kuaaApi from "@/kuaa/kuaa-api";
import URL_CONST from "@/kuaa/kuaa-url-const";
import kuaaFnc from "@/kuaa/kuaa-comm-func";


import { Grid } from '@toast-ui/vue-grid';
import 'tui-grid/dist/tui-grid.css';
import 'tui-pagination/dist/tui-pagination.css';

export default {
  components: {
    grid: Grid
  },

  computed: {
    total() {
      return this.pagination.total;
    }
  },

  data() {
    return {
      // 교우직위
      memberOrgGbList: [],
      // 회원등급
      memberLevelList: [],
      feeLevelList: [],

      query: {
        memberorgGb: "",
        memberGb: "", // 평생회원 여부 Y/N
        feeCountFrom: "",
        feeCountTo: "",
        mlevelCd: ""
      },

      // 검색 결과 리스트
      tableData: [],

      pagination: {
        perPage: 20,
        page: 1,
        perPageOptions: [20, 50, 100, 200, 500],
        total: 0
      },

      selectedRows: [],
      updatableMemberLevel: "",
    }
  },

  created() {
    this.initGrid();
    this.queryMemberOrgTypes();
    this.queryMemberLevelTypes();
    this.queryFeeLevelTypes();
  },

  methods: {
    /**
     * 임원 레벨코드 - 공통코드 조회 세팅
     */
    queryMemberOrgTypes() {
      kuaaFnc.fncOrgLevelList(null,res => {
        this.memberOrgGbList = res.data.data.contents;
      });
    },

    /**
     * 기존등급 - 공통코드 조회
     */
    queryMemberLevelTypes() {
      kuaaFnc.fncMemberLevelTypes(null,res => {
        this.memberLevelList = res.data.data.contents;
      });
    },

    /**
     * 기존등급 - 공통코드 조회
     */
    queryFeeLevelTypes() {
      kuaaFnc.fncFeeLevelCdTypes(null,res => {
        this.feeLevelList = res.data.data.contents;
      });
    },

    searchQuery() {
      this.$refs.feeCountLevelListGrid.invoke("readData", 1, this.query);
    },

    /**
     * 검색조건 초기화
     */
    clearQuery() {
      this.query = {
        memberorgGb: "",
        memberGb: "", // 평생회원 여부 Y/N
        feeCountFrom: "",
        feeCountTo: "",
        mlevelCd: ""
      };
    },


    selectRow(rowList){
      this.selectedRows = rowList;
    },

    bundleUpdate(){
      let params = JSON.parse(JSON.stringify(this.query));
      params['feeLevelCd'] = this.updatableMemberLevel;

      if(!params['feeLevelCd'] || params['feeLevelCd'] == ''){
        kuaaFnc.showSwal("납부회수 등급 저장", '회원 등급을 선택 해 주세요');
        return;
      }

      kuaaApi.sendServer(
        URL_CONST.UPDATE_MEMBER_LEVEL_LIST,
        params,
        "post",
        response => {
          if (response.result){
            kuaaFnc.showSwal("납부회수 등급 저장", '업데이트 하였습니다.');
            this.searchQuery();
          } else {
            kuaaFnc.showSwal("납부회수 등급 저장", response.resultMessage);
          }
        }
      );
    },

    perPageChange(event) {
      kuaaFnc.resetPagenation(this.$refs.feeCountLevelListGrid, event, this.pagination);
    },

    initGrid() {
      this.gridProps = kuaaFnc.setGridInit(URL_CONST.GET_MEMBER_FEE_CNT_LIST, false, this.pagination);
      this.gridProps['el'] = this.$refs.feeCountLevelListGrid;
      this.gridProps['columns']= [
          {header: '교우번호', name: 'memberNo', width:120, align:"center", sortable: true},
          {header: '교우명', name: 'memberHnm', width:120, sortable: true},
          {header: '교우직위', name: 'memberorgGbNm', width:100, sortable: true},
          {header: '성별', name: 'sex', align:"center", sortable: true},
          {header: '생년월일', name: 'birthday', width:100, align:"center", sortable: true,
            formatter(value) {
              return (value.value && value.value.length == 8) ? formatter.getDateFormat(value.value) : value.value;
            }
          },
          {header: '대학명', name: 'collegeNm', width:150, sortable: true},
          {header: '학과명', name: 'classNm', width:180, sortable: true},
          {header: '졸업회수', name: 'graduationNo', width:100, align:"center", sortable: true},
          {header: '입학년월', name: 'enterYm', align:"center", sortable: true,
            formatter(value) {
              return (value.value && value.value.length == 6) ? formatter.getDateFormat(value.value) : value.value;
            }
          },
          {header: '졸업년월', name: 'graduationYm', align:"center", sortable: true,
            formatter(value) {
              return (value.value && value.value.length == 6) ? formatter.getDateFormat(value.value) : value.value;
            }
          },
          {header: '학번', name: 'hakbun', width:80, align:"center", sortable: true},
          {header: '회비등급', name: 'feelevelNm', width:110, align:"center", sortable: true},
          {header: '납입횟수', name: 'feeCnt', width:110, align:"center", sortable: true},
          {header: '평생회비납부', name: 'memberGb', width:100, align:"center", sortable: true},
          {header: '휴대폰', name: 'cellular', width:100, align:"center", sortable: true},
          {header: '이메일', name: 'eMail', width:150, sortable: true}
        ];
    },

    response(e) {
      if (this.instance == null) {
        this.instance = e.instance;
      }
      let res = JSON.parse(e.xhr.response);
      if(res.result){
        this.pagination.total = res.data.pagination.totalCount;
      }else{
        kuaaFnc.gridErrorCallback(e,"납부회수 등급관리");
      }
    },

    downloadExcel() {      
      this.query.page = 1;
      this.query.perPage = this.pagination.total;
      this.query.fileName = '납부회수_등급관리';      
      kuaaApi.requestFileDownload(        
          URL_CONST.PAYMENT_EXCEL_DOWNLOAD,
          this.query,
          '납부회수_등급관리.xlsx',
          response => {
            this.query.page = this.pagination.page;
            this.query.perPage = this.pagination.perPage;
          }
      );
    }

  }
}
</script>

<style>

</style>